import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "./SEO";

const DEFAULT_TITLE = "Crypsey";
const DEFAULT_DESCRIPTION =
  "Crypsey - AI-powered, real-time mortgage analytics and insights for lenders, PropTech companies, and mortgage professionals.";

export default function RouteSEO() {
  const { pathname } = useLocation();

  // Default
  let title = DEFAULT_TITLE;
  let description = DEFAULT_DESCRIPTION;
  let canonicalPath = pathname || "/";

  if (pathname === "/" || pathname === "/mortgagechain") {
    title = "Crypsey - AI-Powered Mortgage Analytics";
    canonicalPath = "/";
  } else if (pathname === "/docs" || pathname === "/mortgagechain/docs") {
    title = "API Docs - Crypsey";
    canonicalPath = "/docs";
  } else if (
    pathname === "/privacy-policy" ||
    pathname === "/mortgagechain/privacy-policy"
  ) {
    title = "Privacy Policy | Crypsey";
    canonicalPath = "/privacy-policy";
  } else if (
    pathname === "/terms-of-service" ||
    pathname === "/mortgagechain/terms-of-service"
  ) {
    title = "Terms of Service | Crypsey";
    canonicalPath = "/terms-of-service";
  } else if (
    pathname === "/risk-disclosures" ||
    pathname === "/mortgagechain/risk-disclosures"
  ) {
    title = "Risk Disclosures | Crypsey";
    canonicalPath = "/risk-disclosures";
  } else if (pathname === "/pitch-deck") {
    title = "Pitch Deck | Crypsey";
    canonicalPath = "/pitch-deck";
  }

  return (
    <SEO
      title={title}
      description={description}
      canonicalPath={canonicalPath}
    />
  );
}
